import { Game, GameKind } from "../../../gql/graphql";
import { QuickrankChart } from "../QuickrankChart";
import { RankifierChart } from "../RankifierChart";
import { SwiperChart } from "../SwiperChart";
import { TriviaChart } from "../TriviaChart/TriviaChart";
import { WordleChart } from "../WordleChart";
import { WordopolisChart } from "../WordopolisChart";

export type GameForReport = Pick<Game, "id" | "name" | "kind" | "responseCount"> & {
  configuration: {
    id: string;
    showRatingScale?: boolean;
  };
};

export interface GameReportProps {
  game: GameForReport;
}

export const GameReport = ({ game }: GameReportProps) => {
  return {
    [GameKind.Swiper]: <SwiperChart game={game} />,
    [GameKind.QuickRank]: <QuickrankChart game={game} />,
    [GameKind.Rankifier]: <RankifierChart game={game} />,
    [GameKind.Wordopolis]: <WordopolisChart game={game} />,
    [GameKind.Trivia]: <TriviaChart game={game} />,
    [GameKind.Wordle]: <WordleChart game={game} />,
  }[game.kind];
};
